import {
  FeedstockQuantities,
  FeedstockQuantitiesPropName
} from '../../../../models/project/feedstock/feedstock-quantities.model';
import { ProjectValidationUnit } from '../../../../models/data-structures/project-validation';
import { UnitValueValidation } from '../unit-value.validation';

export class FeedstockQuantitiesValidation {
   /** The current feedstock quantities obj that is being validated */
  quantities: FeedstockQuantities;

  /**
   * Sets the feedstock quantities that will be used for validation
   * @param quantities will be used to set the current feedstock quantities
   */
  constructor(quantities: FeedstockQuantities) {
    if (!quantities) throw Error('invalid feedstock quantities provided for validation');
    this.quantities = new FeedstockQuantities(quantities);
  }

  /**
   * Get a validation unit containing the validation data for the current feedstock quantities obj
   */
  getValidation(): ProjectValidationUnit {
    if (!this.quantities) throw Error('unable to validate feedstock quantities');
    const validationUnit = new ProjectValidationUnit();
    if (this.quantities.isAnimal) {
      validationUnit.addModuleResults(
        new UnitValueValidation(this.quantities.numAnimals).getValidation(),
        FeedstockQuantitiesPropName.numAnimals
      );
      validationUnit.addModuleResults(
        new UnitValueValidation(this.quantities.manureProduction).getValidation(),
        FeedstockQuantitiesPropName.manureProduction
      );
    } else {
      validationUnit.addModuleResults(
        new UnitValueValidation(this.quantities.mass).getValidation(),
        FeedstockQuantitiesPropName.mass
      );
    }
    validationUnit.addModuleResults(
      new UnitValueValidation(this.quantities.period).getValidation(),
      FeedstockQuantitiesPropName.period
    );
    return validationUnit;
  }

  /**
   * returns a boolean that determines if the current feedstock quantities obj is valid
   */
  isValid() {
    return this.getValidation().isValid;
  }
}
